(function (ebusy, $) {

    ebusy.bookingTableUtils = ebusy.bookingTableUtils || {};
    ebusy.bookingTableUtils.styles = ebusy.bookingTableUtils.styles || {};
    ebusy.bookingTableUtils.styles["T_CARD_BOARD"] = {};

    /**
     * Removes a single reservation from the booking table.
     */
    ebusy.bookingTableUtils.styles["T_CARD_BOARD"].removeReservation = function (reservationId, table) {

        var cells = ebusy.bookingTableUtils.getCellsById(reservationId, table);

        if(!cells.length) {
            return;
        }

        cells.removeClass("reservation");

        cells.addClass("slot");

        cells.data("reservation-id", "");

        cells.find(".reservation-content").remove();
        cells.find(".slot-label").show();
    }

    /**
     * Applies a single reservation to the booking table.
     */
    ebusy.bookingTableUtils.styles["T_CARD_BOARD"].createReservation = function(reservation, cells, table, moduleConfig) {

        cells.find(".reservation-content").data("reservation-id", reservation.id);

        cells.removeClass("slot");

        cells.addClass("reservation");
        cells.data("reservation-id", reservation.id);
        cells.data("booking-id", reservation.booking);

        if(reservation.notComplete) {
            cells.addClass("not-complete");
        }

        cells.find(".slot-label").hide();

        for(var i = 0; i !== cells.length; ++i) {
            cells.eq(i).append(createReservationMarkup(reservation, i, moduleConfig));
        }

        if(moduleConfig.view === "WEEK") {
            cells.find(".card").hide();
            cells.find(".reservation-content").each(function() {

                var backgroundColor = $(this).find(".card").css("backgroundColor");
                if(backgroundColor) {
                    $(this).css("backgroundColor", backgroundColor);
                } else if($(this).find(".card").hasClass("background-color-primary")) {
                    $(this).addClass("background-color-primary");
                } else if($(this).find(".card").hasClass("background-color-primary-lightened")) {
                    $(this).addClass("background-color-primary-lightened");
                }
            });
        }

        if (!ebusy.app && reservation.showDetailsLink) {

            var link;

            if(reservation.blocking) {
                link = "/" + moduleConfig.type + "-module/" + ebusy.moduleId + "/blockings/" + reservation.liteBlocking + "/details";
            } else {
                link = "/" + moduleConfig.type + "-module/" + ebusy.moduleId + "/bookings/" + reservation.booking + "/details";
            }

            link += "?currentReservation=" + reservation.id;
            cells.find(".reservation-content").data("link", link);
        }
    }

    /**
     * Creates markup for a reservation.
     */
    function createReservationMarkup(reservation, index, moduleConfig) {

        var text;
        if(index === 0) {
            text = reservation.text;
        } else if(index <= reservation.additionalPlayers.length) {
            text = reservation.additionalPlayers[index - 1].text;
        } else {
            text = reservation.blocking ? reservation.text : moduleConfig.playerTypeOccupied;
        }

        var div = $("<div>", {
            "class": "reservation-content",
            title: text,
            "data-toggle": "tooltip",
            "data-placement": "top"
        });

        var subElem = $("<div>", {
            "class": "card"
        });

        var shortText;
        if(index === 0) {
            shortText = reservation.shortText;
        } else if(index <= reservation.additionalPlayers.length) {
            shortText = reservation.additionalPlayers[index - 1].shortText;
        } else {
            shortText = reservation.blocking ? reservation.shortText : moduleConfig.playerTypeOccupied;
        }

        if(reservation.color) {
            subElem.css({ backgroundColor: index === 0 ? reservation.color : ebusy.hexToRgba(reservation.color, 0.5) });
        } else if (index === 0) {
            subElem.addClass("background-color-primary");
        } else {
            subElem.addClass("background-color-primary-lightened");
        }

        subElem.append($("<span>", {"class": "name desktop-view-only text-truncate", text: text}));
        subElem.append($("<span>", {"class": "name mobile-view-only text-color-primary text-truncate", text: shortText}));

        if(index === 0) {
            subElem.append($("<span>", {
                "class": "info desktop-view-only text-truncate",
                text: reservation.info
            }));
        }

        if(reservation.textColor === 'WHITE') {
            subElem.find("span").css({ color: '#ffffff' });
        } else if(reservation.textColor === 'BLACK') {
            subElem.find("span").css({ color: '#000000' });
        } else if(!reservation.textColor) {
            subElem.find("span").addClass('text-color-primary');
        }

        return div.append(subElem);
    }

})(window.ebusy = window.ebusy || {}, window.jQuery);
